import styled from 'styled-components';

export const TextInput = styled.input`
  box-sizing: border-box;
  padding: 5px;
  border: 1px solid gray;
  border-radius: 3px;
  font-size: 14px;
`;
